import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
    getWorkflowPhoneNumbers,
    WorkflowPhoneNumbersParams,
} from 'services/api/getWorkflowPhoneNumbers';
import { queryKeys } from '../queryKeys';

export const useGetWorkflowPhoneNumbers = (params: WorkflowPhoneNumbersParams) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.workflowPhoneNumbers(params),
        queryFn: () => getWorkflowPhoneNumbers(params),
        placeholderData: keepPreviousData,
        enabled: !!params.workflowId,
    });

    return {
        phoneNumbers: data,
        isPhoneNumbersLoading: isLoading,
        isPhoneNumbersFetching: isFetching,
        ...rest,
    };
};
